import React from 'react';
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

export const LoadingState: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col items-center justify-center p-8 space-y-4"
    >
      <div className="w-8 h-8 border-4 border-orange-200 border-t-orange-800 rounded-full animate-spin" />
      <div className="text-orange-800 text-center">
        {isMobile ? "Søker..." : "Søker og analyserer lover og forskrifter..."}
      </div>
    </motion.div>
  );
};